interface ViewInputVarsModalProps {
  vars: Record<string, string>;
  onClose: () => void;
}

export function ViewInputVarsModal({ vars, onClose }: ViewInputVarsModalProps) {
  const entries = Object.entries(vars);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-lg w-full max-w-md mx-4 max-h-[90vh] flex flex-col">
        <div className="px-6 pt-6 pb-4 overflow-y-auto flex-1">
          <h2 className="text-lg font-bold text-gray-900 mb-4">Input Variables</h2>
          {entries.length === 0 ? (
            <p className="text-sm text-gray-400">None</p>
          ) : (
            <div className="divide-y divide-gray-100">
              {entries.map(([key, value]) => (
                <div key={key} className="py-2">
                  <p className="text-xs font-medium text-gray-500">{key}</p>
                  <p className="text-sm text-gray-900 mt-0.5">{value}</p>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="flex items-center justify-end px-6 py-4 border-t border-gray-100">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
